/** Kept to one line — the detail lives in the work below. */
const stack: string[] = ['TypeScript', 'React', 'Next.js', 'Node.js', 'Nest.js', 'Python', 'FastAPI', 'Golang', 'Temporal', 'PostgreSQL', 'Redis', 'Docker', 'AWS'];

export default stack;
